import React, { Component } from 'react';
import Highlighter from "react-highlight-words";
import { connect } from 'react-redux';
import DoublePanel, { sortCaret } from '../../../components/common/DoublePanel/DoublePanel';
import { AppState } from '../../../store';
import IconBuilder from '../../../utilities/iconBuilder/IconBuilder';
import Overview from '../Overview/Overview'
import { CSVLink } from "react-csv";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import "./VehicleTable.css"

interface VehicleProps {
    vehicles: any
    input: string
    fleetReference: any
    sideMenuOpen: boolean;
}

class VehicleTable extends Component<VehicleProps>{
    //default active key for the tabs in Overview.tsx is Inspections
    //setActiveKey is called from Overview.tsx to keep in memory what
    //tab a user is on.
    activeKey = "Inspections"

    setActiveKey = (key: string) => {
        this.activeKey = key
    }

    render() {

        //console.log("Vehicle List", this.props.vehicles)

        const csvTooltip = (
            <Tooltip id="vt-pin-tooltip">
                Download CSV
            </Tooltip>
        )

        const needsInspectionReviewTooltip = (
            <Tooltip id="vt-pin-tooltip">
                Waiting Inspection Review
            </Tooltip>
        )

        const pastDueMaintenanceTooltip = (
            <Tooltip id="vt-pin-tooltip">
                Past Due Maintenance
            </Tooltip>
        )

        const maintenanceReviewTooltip = (
            <Tooltip id="vt-pin-tooltip">
                Waiting Maintenance Review
            </Tooltip>
        )

        return (
            <div className="VehicleTable">
                <DoublePanel
                    manual
                    url=""
                    data={this.props.vehicles}
                    keyField="VehicleNumber"
                    wrapperClassName="test"
                    turnIntoModal={false}
                    columns={[
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Vehicle #",
                            dataField: "VehicleNumber",
                            formatter: (cell: any, vehicle: any) => (
                                <div className="VehicleTableCellOne">
                                    <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />
                                    {cell && <div className="VehicleTableWarningIcons" id={`vehicle-table-warning-icons-${cell}`}>
                                        {vehicle.NeedsReviewed === "1" && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={needsInspectionReviewTooltip}>
                                            <span id={cell + "-waiting-inspection"} className="material-icons fleet-cell-waiting-inspection-review">priority_high</span>
                                        </OverlayTrigger>}
                                        {vehicle.CountPastDueMaintenance > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={pastDueMaintenanceTooltip}>
                                            <span id={cell + "-maintenance-overdue"} className="material-icons fleet-cell-overdue-maintenance">query_builder</span>
                                        </OverlayTrigger>}
                                        {vehicle.NeedsMaintenanceReview === "1" && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={maintenanceReviewTooltip}>
                                            <span id={cell + "-maintenance-wating-review"} className="material-icons fleet-cell-waiting-maintenance-review">build</span>
                                        </OverlayTrigger>}


                                    </div>}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Year",
                            dataField: "Year",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-Year-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Make / Model",
                            dataField: "VehicleMakeAndModel",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-make-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Vin",
                            dataField: "VinNumber",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-VinNumber-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Status",
                            dataField: "VehicleStatusTypeDescription",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-VehicleStatusTypeDescription-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Location",
                            dataField: "ProfitCenterLongDesc",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-ProfitCenterLongDesc-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Mileage",
                            dataField: "Mileage",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-Mileage-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                        {
                            sort: true,
                            sortCaret: sortCaret,
                            text: "Last Driver",
                            dataField: "LastDriver",
                            formatter: (cell: any, vehicle: any) => (
                                <div id={"vehicle-table-last-driver-column-" + vehicle.VehicleNumber}>
                                    {cell && <Highlighter
                                        highlightClassName="VehicleTable"
                                        searchWords={[this.props.input]}
                                        autoEscape={true}
                                        textToHighlight={cell.toString() || "NA"}
                                    />}
                                </div>
                            ),
                            headerFormatter: (column: any, colIndex: number, components: any) => {
                                return (
                                    <div className="d-flex align-items-center Vehicle-Table-Header-Formatter">
                                        {column.text}
                                        {components.sortElement}
                                    </div>
                                )
                            }
                        },
                    ]}
                    Header={() => {
                        return (
                            <div className="VehicleTableHeaderTempFix">
                                {this.props.vehicles.length > 1 && <div className="Vehicle-Table-Header-Wrapper">
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={csvTooltip}>
                                        <CSVLink data={this.props.vehicles} filename="Vehicles.csv"><IconBuilder extension="csv" size={32}></IconBuilder></CSVLink>
                                    </OverlayTrigger>
                                    <h1 id="result-count">Showing {this.props.vehicles.length} Results</h1>
                                </div>}
                                {this.props.vehicles.length === 1 && <div className="Vehicle-Table-Header-Wrapper">
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={csvTooltip}>
                                        <CSVLink data={this.props.vehicles} filename="Vehicles.csv"><IconBuilder extension="csv" size={32}></IconBuilder></CSVLink>
                                    </OverlayTrigger>
                                    <h1 id="result-count">Showing {this.props.vehicles.length} Result</h1>
                                </div>}
                            </div>
                        )
                    }}
                    DetailPanel={({ details, handleClose }: any) =>
                        // <div className={"Vehicle-Detail-Panel-Sm-Open-" + this.props.sideMenuOpen}>
                        <div className={"Vehicle-Detail-Panel-Sm-Open-true"}>
                            <p id="fleet-overview-close-btn" onClick={handleClose}><span className="material-icons">close</span></p>
                            <p id="fleet-overview-close-btn-editing" style={{ display: "none" }}><span className="material-icons">close</span></p>
                            <div className="Fleet-Overview-Header">
                                <p>{"ID: " + details.VehicleInformationId}</p>
                            </div>
                            <Overview
                                details={details}
                                fleetReference={this.props.fleetReference}
                                activeKey={this.activeKey}
                                setActiveKey={this.setActiveKey}
                            />
                        </div>
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    sideMenuOpen: state.menu.sideMenuOpen
})

export default connect(mapStateToProps)(VehicleTable)